import React, {useEffect, useRef, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {LookerEmbedSDK} from "@looker/embed-sdk";
import MindsetsJsSDK, {ErrorMessageAction, LoadingAction} from "mindsets-js-sdk";

import useAuth from "../../hooks/useAuth";
import {
    LoadedLookerDashboardConfigsAction,
    LoadLookerDashboardConfigsAction,
    SetPerformanceMenuDistrictIdAction
} from "../../actions/performance_actions";
import Menu from "./Menu";

import "./performance_dashboard.scss";

export default function () {
    useAuth(['teacher']);

    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const me = useSelector(state => state.me);
    const performance_configs = useSelector(state => state.performance_configs);
    const district_id = useSelector(state => state.performance_menu_district_id);
    const [dashboard_id, setDashboardId] = useState(null);
    const overlayRef = useRef();

    function getDashboardId(performance_configs, slug, district_id) {
        const district_ids = [...new Set(performance_configs.map(config => config.district_id))];
        const configs = performance_configs.filter((config, i) => {
            if (district_ids.length > 1 && district_id && config.district_id !== district_id) {
                return false;
            }
            if (district_ids.length > 1 && !district_id && me && me.school && config.district_id !== me.school.district_id) {
                return false;
            }

            return !(slug && config.slug !== slug);
        });
        if (configs.length > 0 && configs[0].dashboard_id !== dashboard_id) {
            document.getElementById('dashboard').replaceChildren();
            setDashboardId(configs[0].dashboard_id);
        }
    }

    function acquireEmbedSession() {
        return MindsetsJsSDK().API.get('looker/session').then(response => response.tokens);
    }

    function generateEmbedTokens() {
        return MindsetsJsSDK().API.put('looker/tokens').then(response => response.tokens);
    }

    useEffect(() => {
        if (dashboard_id) {
            overlayRef.current.style.display = 'block';
            dispatch(LoadingAction(true, 'Please wait while we load your Mindsets data!'));
            LookerEmbedSDK.createDashboardWithId(dashboard_id)
                .withDynamicIFrameHeight()
                .withAllowAttr('fullscreen')
                // .on('dashboard:loaded', () => console.log('dashboard:loaded'))
                // .on('dashboard:run:start', () => console.log('dashboard:run:start'))
                .on('dashboard:run:complete', () => {
                    dispatch(LoadingAction(false));
                    overlayRef.current.style.display = 'none';
                })
                // .on('dashboard:edit:start', () => console.log('dashboard:edit:start'))
                // .on('dashboard:edit:cancel', () => console.log('dashboard:edit:cancel'))
                // .on('dashboard:save:complete', () => console.log('dashboard:save:complete'))
                // .on('dashboard:delete:complete', () => console.log('dashboard:delete:complete'))
                // .on('session:status', (event) => console.log('session:status: ', event))
                // .on('dashboard:tile:explore', () => console.log('dashboard:tile:explore'))
                // .on('dashboard:tile:view', () => console.log('dashboard:tile:view'))
                .appendTo('#dashboard')
                .build()
                .connect()
                .catch((error) => {
                    console.error('Connection error: ', error)
                });
        }
    }, [dashboard_id]);

    useEffect(() => {
        getDashboardId(performance_configs, params.slug, district_id);
    }, [params.slug]);

    useEffect(() => {
        if (window.location.pathname === '/performance') {
            getDashboardId(performance_configs, params.slug, district_id);
        } else {
            navigate('/performance');
        }
    }, [district_id]);

    useEffect(() => {
        if (me && me.school) {
            dispatch(LoadLookerDashboardConfigsAction()).then(configs => getDashboardId(configs, params.slug, district_id)).catch(error => {
                dispatch(ErrorMessageAction(error));
                console.error(error);
            });
        }
    }, [me]);

    useEffect(() => {
        LookerEmbedSDK.initCookieless(
            'mindsets.cloud.looker.com',
            acquireEmbedSession,
            generateEmbedTokens
        );
    }, []);

    useEffect(() => {
        return () => {
            setDashboardId(null);
            dispatch(SetPerformanceMenuDistrictIdAction(null));
            dispatch(LoadedLookerDashboardConfigsAction([]));
        }
    }, []);

    return (
        <div id='performance-dashboard'>
            <Menu/>
            <div id='dashboard-wrapper'>
                <div id='dashboard'/>
                <div id='dashboard-overlay' ref={overlayRef}/>
            </div>
        </div>
    );
}
